import * as React from 'react';
import { DEFAULT_CONTEXT } from './constants';
import type { Context } from './types';

const DeviceContext = React.createContext<Context>(DEFAULT_CONTEXT);
export default DeviceContext;
